export const API_EXTERNAL_ENDPOINT = 'home'

export const API_INTERNAL_ENDPOINT = 'strapi/home'
